module.exports = __webpack_public_path__ + "static/img/vl2_service_manual.83c8b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/vl2_service_manual.png
// module id = AXcL
// module chunks = 0